<template>
	<v-card>
		<v-card-title class="title font-weight-bold white--text primary">{{ LocationSelected.DivisionName }}: {{ LocationSelected.LocationName }}</v-card-title>
		<v-divider></v-divider>
		<v-layout row wrap>
			<v-flex xs12 sm7 md7 lg8 xl9>
				<v-container v-if="HaveSessionData" class="TeamContainer ma-0 pa-0">
					<v-layout row>
						<v-flex v-for="data in LocationSelected.SessionData" :key="data.CropWorkSessionID" shrink>
							<v-card class="TeamCard">
								<v-card-title class="subheading font-weight-bold">Team: {{ data.TeamName }}</v-card-title>
								<v-divider></v-divider>
								<v-list dense>
									<v-list-tile>
										<v-list-tile-content>Activity:</v-list-tile-content>
										<v-list-tile-content class="align-end">{{ data.CropWorkActivityDescription }}</v-list-tile-content>
									</v-list-tile>
									<v-list-tile>
										<v-list-tile-content>Units Processed:</v-list-tile-content>
										<v-list-tile-content class="align-end">{{ data.TotalUnit | formatNumberTo0Decimals }} {{ data.CropWorkActivityUnitOfMeasure }}</v-list-tile-content>
									</v-list-tile>
									<v-list-tile>
										<v-list-tile-content>Worker Hours:</v-list-tile-content>
										<v-list-tile-content class="align-end">{{ data.TotalHours | formatNumberTo2Decimals }} hour(s)</v-list-tile-content>
									</v-list-tile>
									<v-list-tile>
										<v-list-tile-content>Average Rate:</v-list-tile-content>
										<v-list-tile-content class="align-end">{{ data.AverageHourlyRate | formatNumberTo2Decimals }} {{ data.CropWorkActivityUnitOfMeasure }}/hour</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
export default {
	props: {
		locationSelected: {
			type: Object,
			required: true
		}
	},
	data(){
		return {

		}
	},
	computed: {
		LocationSelected(){
			return this.locationSelected;
		},
		LocationVarieties() {
			if (this.LocationSelected && this.LocationSelected.Varieties) {
				return this.LocationSelected.Varieties;
			} else {
				return [];
			}
		},
		HaveSessionData: function () {
			if (this.LocationSelected && this.LocationSelected.SessionData && this.LocationSelected.SessionData.length > 0) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {

	}
}
</script>